import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-class',
  standalone: false,
  templateUrl: './class.component.html',
  styleUrl: './class.component.scss'
})
export class ClassComponent implements OnInit, OnDestroy {
  title = 'Class Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  private subscriptions = new Subscription();
  system: any[] = [];
  // isCardView: boolean = true;
  cols: any[] = [
    { field: 'name', header: ' Name', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'description', header: 'Description', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px' },

  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false;
  selectedClassData: any = {};
  viewMode: boolean = false;
  
  // Dialog configurations
  addDialogConfig: DialogConfig;
  updateDialogConfig: DialogConfig;

  constructor(private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    this.initializeDialogConfigs();
  }

  private initializeDialogConfigs(): void {
    const classFields: FormField[] = [
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        placeholder: 'Enter Class Name',
        maxLength: 100,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'description',
        label: 'Description',
        type: 'textarea',
        placeholder: 'Enter Description',
        maxLength: 500,
        validation: {
          required: true
        }
      }
    ];

    this.addDialogConfig = {
      title: 'Create Class',
      width: '60vw',
      fields: classFields,
      formLayout: 'single-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-class-dialog'
    };

    this.updateDialogConfig = {
      title: 'Update Class',
      width: '60vw',
      fields: classFields,
      formLayout: 'single-column',
      submitButtonText: 'Update',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-class-dialog'
    };
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/class-master/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
      let resp = res.data || res.results
      this.totalRecords = res.count || 0
      this.system = resp.map((item: any) => ({
        ...item,
        section: item.section?.name,
        sectionName: item.section?.name || '',
        sectionCode: item.section?.code || '',
        status: item.status === 1 ? 'Active' : 'Inactive' // readable status
      }));
    });
    this.subscriptions.add(sub);
  }


  addSystem() {
    this.selectedClassData = {};
    this.showDialog = true;
  }

  onSubmitAdd(formData: any) {
    let payload = {
      name: formData.name,
      description: formData.description,
    };
    
    const sub = this.api.postAPI('/master/class-master/', payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Class submitted successfully'
        });
        this.showDialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: res.name || 'Failed to create class'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelAdd() {
    this.showDialog = false;
  }

  onCloseAdd() {
    this.showDialog = false;
  }
  viewSystem(rowData: any) {
    this.viewMode = true;
    this.updateDialogConfig.title = 'View Class';
    if (rowData && rowData.id) {
      this.selectedsystem = rowData;
      this.isUpdatedialog = true;
      
      // Map data for the reusable dialog
      this.selectedClassData = {
        name: rowData.name || '',
        description: rowData.description || ''
      };
    }
  }

  updateSystem(equipment: any): void {
    this.viewMode = false;
    this.updateDialogConfig.title = 'Update Class';
    this.isUpdatedialog = true;
    this.selectedsystem = equipment;
    
    // Map data for the reusable dialog
    this.selectedClassData = {
      name: equipment.name || '',
      description: equipment.description || ''
    };
  }


  onSubmitUpdate(formData: any) {
    let sectionId = this.selectedsystem.id;
    let payload = {
      name: formData.name,
      description: formData.description,
    };
    
    const sub = this.api.putAPI(`/master/class-master/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Class updated successfully'
        });
        this.isUpdatedialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: res.detail || 'Failed to update class'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelUpdate() {
    this.isUpdatedialog = false;
  }

  onCloseUpdate() {
    this.isUpdatedialog = false;
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    // this.selectedsystem = equipment;
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/class-master/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Class Deleted Successfully',
        });
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/class', 'Edit') ||
      this.permissionService.hasPrivilege('/master/class', 'Delete')||
      this.permissionService.hasPrivilege('/master/class', 'View');
  }
}
